import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {getBreakLinesTextShumaType3} from '../../../utils/texts';
import styles from './styles.module.scss';

const Section6Text713a = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {propertyPopulatedNotes} = context.data.pdfData;

  return (
    <div ref={ref}>
      {propertyPopulatedNotes && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span>{getBreakLinesTextShumaType3(propertyPopulatedNotes)}</span>
        </div>
      )}
    </div>
  );
});

export default Section6Text713a;
